// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"349":"07a72f6ed6ab51106cb9","665":"e79e8e0170361293d01c","833":"ecedc4d85481fb1985e3","913":"52f14fc50b05d5eadc94","926":"5f6fb67fad17f23d2cbd"}[chunkId] + ".chunk.js";
};